import React, { useLayoutEffect, useRef } from 'react';

export interface EditoHTMLProps {
  content?: string;
  background?: string;
}

const EditoHTML = (props: EditoHTMLProps) => {
  const { content, background } = props;
  const elRef = useRef<HTMLDivElement>();

  useLayoutEffect(() => {
    const range = document.createRange();
    range.selectNode(elRef.current);
    const documentFragment = range.createContextualFragment(content);
    elRef.current.innerHTML = '';
    elRef.current.append(documentFragment);
  }, []);
  if (!content) return null;
  return (
    <div
      ref={elRef}
      className="editoHTML"
      dangerouslySetInnerHTML={{ __html: content }}
      nonce="__nonce__"
      style={background ? { background } : null}
    />
  );
};

export default EditoHTML;
